import { createStyles, makeStyles, Theme } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    item: {
      borderColor: theme.palette.grey.A700,
      borderWidth: theme.spacing(0.2),
      borderStyle: "solid",
      boxShadow: theme.shadows[5],
      overflow: "hidden", // ensures cropped image corners don't spill out
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
    },
    selectedItem: {
      borderColor: theme.palette.success.main,
      borderWidth: theme.spacing(0.4),
      borderStyle: "solid",
      boxShadow: theme.shadows[5],
      overflow: "hidden", // ensures cropped image corners don't spill out
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
    },
    img: {
      objectFit: "cover",
      display: "block",
    },
    imgBar: {
      height: theme.spacing(3),
      width: "100%",
    },
    imgPlaceholder: {
      fontSize: 240,
      color: theme.palette.grey.A100,
      width: 150,
      height: 150,
    },
  })
);
